/*
 * Banner messages — the site-chrome notification strip.
 *
 * The banner is looked up per call from the given root (default `document`),
 * so a page with more than one banner region cannot have one call stomp on
 * another's element. The pending show timeout is held per banner element in a
 * WeakMap rather than a module-level variable, for the same reason.
 */
const showTimeouts = new WeakMap();
const dismissHandlers = new WeakMap();

const clearShowTimeout = banner => {
	const timeout = showTimeouts.get(banner);
	if (timeout) {
		clearTimeout(timeout);
		showTimeouts.delete(banner);
	}
};

const hide = banner => {
	clearShowTimeout(banner);
	banner.classList.remove('is-showing');
	banner.setAttribute('aria-live', 'off');
};

const hideMessage = (root = document) => {
	const banner = root.querySelector('[data-banner]');
	if (!banner) return;

	hide(banner);
};

const showMessage = (message, type = 'error', instant = 0, root = document) => {
	const banner = root.querySelector('[data-banner]');
	if (!banner) return;

	const messageElement = banner.querySelector('[data-message]');
	const dismissElement = banner.querySelector('[data-dismiss]');
	if (!messageElement || !dismissElement) return;

	hide(banner);

	banner.dataset.banner = type;
	messageElement.textContent = message;

	showTimeouts.set(
		banner,
		setTimeout(() => {
			banner.classList.add('is-showing');
			banner.setAttribute('aria-live', 'assertive');
			showTimeouts.delete(banner);
		}, instant)
	);

	// Bind the dismiss handler once per button — repeat showMessage calls
	// must not stack listeners on the same element.
	if (!dismissHandlers.has(dismissElement)) {
		const onDismiss = () => hide(banner);
		dismissHandlers.set(dismissElement, onDismiss);
		dismissElement.addEventListener('click', onDismiss);
	}
};

export { showMessage, hideMessage };
